import { set, toggle } from '@/utils/vuex'
import { generateTimestamp } from '@/utils/helper'

export default {
  setAttestationAccountsData (state, data) {
    console.log('setting accounts', data)
    state.attestationAccounts = data
  },

  setLoadingAccountData (state, data) {
    state.loadingAccountData = data
  },

  clearAttestationAccountsData (state) {
    state.attestationAccounts = []
  },

  setSelectedAccountData (state, data) {
    state.request = {
      ...state.request,
      Acct_ID: data.Acct_ID,
      Acct_Owner: data.Acct_DL,
      WBS_Code: data.WBS_code,
      Managed_Services: data.Managed_Svc
      // AWS_Support_Type: data.AWS_Support_Type,
      // Opportunity_Id: data.OppReg_Id
    }
  },

  clearFilters (state) {
    state.accountDataFilters = {
      Customer_Id: null,
      Acct_ID: null,
      Acct_Name: null
    }
  },

  updateAttestedAccount (state, data) {
    console.log('updating attested account', data)
    // state.attestationAccounts =
  },

  setInternal (state, data) {
    state.requestIsInternal = data
  },

  setSubmittingAttestation (state, data) {
    state.submitting = data
  },

  setS3File (state, data) {
    state.s3FileUpload = {
      ...state.s3FileUpload,
      item: data
    }
  },

  clearRequest (state) {
    state.isBulkRequest = false
    state.request = {
      Acct_ID: null,
      Acct_Owner: null,
      Financial_Owner: null,
      WBS_Code: null,
      Customer_Name: null,
      Managed_Services: null,
      Acct_Purpose: null,
      Acct_Type: null,
      Provided_Commercial_Service: null,
      Customer_Console_Access: null,
      // AWS_Support_Type: null,
      // Opportunity_Id: null,
      // Internal_Vs_Saas: null,
      // Direct_Vs_Indirect_Access: null,
      // New_Workload: null,
      // SFDC_ID: null,
      // DXC_Services: null,
      // Architecture_Diagram: null,
      // Confirm_Correctness: null,
      Requestor_Id: null
    }
    state.attestationAccounts = []
  },

  setBulkRequest (state, data) {
    state.isBulkRequest = true
    state.request.Acct_ID = data.map(account => account['Account_ID'])
  },

  setFileData (state, data) {
    state.fileData = data
  }
}
